// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2f80ca55","455":"91867536","977":"0546d579"}[chunkId] + ".chunk.js";
};